export const EXTERNAL_REFERRER_KEY = "externalReferrer";
export const INTERNAL_REFERRER_KEY = "internalReferrer";
